import { createFileRoute } from "@tanstack/react-router";

import { MenusHubPage, menusQuery } from "@/components/hubs/MenusHubPage";
import { buildHreflangLinks, buildLocaleMeta, SITE_ORIGIN } from "@/lib/i18n-paths";

const PATH = "/menus";
const TITLE = 'Restaurant menus in Finland — dishes and prices | what Finland';
const DESC = 'Browse published menus from Finnish restaurants, cafés, bars and resorts by cuisine, price range and region.';

export const Route = createFileRoute("/menus/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(menusQuery),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_ORIGIN}${PATH}` },
      ...buildLocaleMeta("en"),
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE_ORIGIN}${PATH}` }, ...buildHreflangLinks(PATH)],
  }),
  component: () => <MenusHubPage locale="en" />,
});
